export default "__VITE_ASSET__DG5LIHAA__"